import classNames from 'classnames';
import { type ComponentProps } from 'react';

export type RecentlyDeletedTableCellProps = ComponentProps<'div'> & {
  width?: number;
};

export const RecentlyDeletedTableCell = ({
  className,
  style,
  width,
  ...restOfProps
}: RecentlyDeletedTableCellProps) => (
  <div
    className={classNames('flex w-full select-none items-center truncate p-2', className)}
    style={{
      flex: width ? `1 0 ${width}px` : '1 1 100%',
      minWidth: width,
      ...style,
    }}
    {...restOfProps}
  />
);
